<template>
    <div class="QCCampaignDetails" v-if="qcCampaign">
        <v-layout align-center class="header-page">
            <div class="page-title">{{ qcCampaign.name }}</div>
            <div class="status-button-group">
                <v-tooltip top z-index="100" v-if="canAssignRole">
                    <template v-slot:activator="{ on }">
                        <div
                            class="icon-permission d-flex align-center justify-center"
                            v-on="on"
                            @click="openQCPermissionEditor"
                        >
                            <img
                                src="/img/permission-grey.svg"
                                alt="open-campaign-permission-editor"
                            />
                        </div>
                    </template>
                    <span>Assign roles</span>
                </v-tooltip>
            </div>
        </v-layout>
        <v-container fluid grid-list-md class="fci-scrollbar content-page">
            <v-tabs
                hide-slider
                class="campaign-detail-tabs"
                v-model="currentTab"
            >
                <v-tab ripple>{{ $f.tc("overview") }}</v-tab>
                <v-tab ripple>{{ $f.tc("batchList") }}</v-tab>
                <v-tab
                    ripple
                    :disabled="!$route.query.batchId || !$route.query.callIndex"
                >
                    {{ $f.tc("currentWork") }}
                </v-tab>
                <v-tab ripple v-if="canEditQCCampaign(qcCampaign.permission)">
                    {{ $f.tc("setting") }}
                </v-tab>
                <v-tabs-items touchless>
                    <v-tab-item>
                        <QCCampaignOverview></QCCampaignOverview>
                    </v-tab-item>
                    <v-tab-item>
                        <QCBatchList
                            @goToStartWork="goToStartWork"
                        ></QCBatchList>
                    </v-tab-item>
                    <v-tab-item>
                        <QCCurrentWork
                            v-if="$route.query.batchId && $route.query.callIndex"
                            :asr-criteria-list="asrCriteriaList"
                            :criteria-list="criteriaList"
                        ></QCCurrentWork>
                    </v-tab-item>
                    <v-tab-item v-if="canEditQCCampaign(qcCampaign.permission)">
                        <QCSetting
                            @updateAsrCriteria="updateAsrCriteria"
                            @updateCriteria="updateCriteria"
                        ></QCSetting>
                    </v-tab-item>
                </v-tabs-items>
            </v-tabs>
        </v-container>
        <QCPermissionEditor ref="QCPermissionEditor" />
    </div>
</template>
<script>
import FormMixin from "@/modules/fptai/mixins/FormMixin";
import RoleMixin from "@/modules/fptai/mixins/RoleMixin";
import QcCampaignService from "@/services/qc.campaign.service";
import QCPermissionEditor from "@/views/QualityControl/Dialog/QCPermissionEditor";
import QCBatchList from "@/views/QualityControl/QCBatchList";
import { mapState } from "vuex";
import QCCurrentWork from "@/views/QualityControl/QCCurrentWork";
import QCCampaignOverview from "@/views/QualityControl/QCCampaignOverview";
import QCSetting from "@/views/QualityControl/QCSetting";

const tabList = ["overview", "batch", "currentWork", "setting"];

export default {
    name: "QCCampaignDetails",
    mixins: [FormMixin, RoleMixin],
    components: {
        QCSetting,
        QCCampaignOverview,
        QCCurrentWork,
        QCPermissionEditor,
        QCBatchList
    },
    data() {
        let urlTab = this.$route.query.tab;
        let tabIndex = 0;
        if (urlTab) {
            tabIndex = tabList.indexOf(urlTab);
            tabIndex = tabIndex >= 0 ? tabIndex : 0;
        }
        return {
            tabList,
            currentTab: tabIndex,
            overviewData: null,
            tableData: [],
            fromDate: "",
            toDate: "",
            dateKey: 1,
            currentPage: 1,
            totalPage: 1,
            itemPerPage: this.$const.itemPerPage,
            totalItems: 0,
            canAssignRole: false,
            asrCriteriaList: [],
            criteriaList: []
        };
    },
    computed: {
        ...mapState({
            qcCampaign: state => state.qccampaign.campaign,
        })
    },
    mounted() {
        QcCampaignService.getQCCampaign(
            this.$route.params["QCCampaignId"]
        ).then(res => {
            this.$store.dispatch(
                this.$actionTypes.qccampaign.SET_DATA,
                res.data
            );
            this.$store.dispatch(
                this.$actionTypes.qccampaign.DATA_INPUT_SUGGESTION,
                this.qcCampaign.id
            );
            this.canAssignRole = RoleMixin.methods.canEditQCCampaign(
                this.qcCampaign.permission
            );
        });
    },
    beforeDestroy() {
        this.$store.commit(this.$actionTypes.qccampaign.SET_TOTAL_CALL, 0);
    },
    methods: {
        openQCPermissionEditor() {
            this.$refs.QCPermissionEditor.open(this.qcCampaign);
        },
        goToStartWork(data) {
            if (!data.index) {
                return;
            }
            this.asrCriteriaList = this.qcCampaign.asr_criteria;
            this.criteriaList = this.qcCampaign.criteria;
            this.$store.commit(
                this.$actionTypes.qccampaign.SET_INDEX_CALL,
                data.index
            );
            let query = this.$utils.cloneObject(this.$route.query);
            query.callIndex = data.index;
            this.$router.push({
                path: `/qc-campaign/${this.$route.params.QCCampaignId}/`,
                query: query
            });
            this.currentTab = 2;
        },
        updateAsrCriteria(data) {
            this.$store.commit(
                this.$actionTypes.qccampaign.UPDATE_ASR_CRITERIA,
                data
            );
            this.asrCriteriaList = data;
        },
        updateCriteria(data) {
            this.$store.commit(
                this.$actionTypes.qccampaign.UPDATE_CRITERIA,
                data
            );
            this.criteriaList = data;
        }
    },
    watch: {
        campaign() {
            setTimeout(this.$forceUpdate, 0);
            this.canAssignRole = RoleMixin.methods.canEditQCCampaign(
                this.qcCampaign.permission
            );
        },
        currentTab: {
            immediate: true,
            handler: function() {
                let query = this.$utils.cloneObject(this.$route.query);
                query.tab = this.tabList[this.currentTab];
                if (query.tab !== 'currentWork') {
                    delete query['callIndex']
                }
                if (query.tab !== 'batch' && query.tab !== 'currentWork') {
                    delete query['batchId']
                }
                this.$router.push({
                    path: `/qc-campaign/${this.$route.params.QCCampaignId}/`,
                    query: query
                });
            }
        }
    }
};
</script>
<style scoped lang="scss">
.header-page {
    background: #ffffff;
    border-bottom: 1px solid #e4edfa;
    padding: 0 20px;
    flex-wrap: wrap;
    height: 63px;
}

.page-title {
    color: #12274f;
    font-size: 22px;
    font-weight: 700;
    flex: 1 !important;
    padding: 10px 0;
}

.content-page {
    background: #f4f7fe;
    padding: 15px 20px !important;
    height: calc(100vh - 123px);
    overflow-y: auto;
}

.status-button-group {
    border-radius: 4px;
    height: 32px;
    display: flex;
    margin-left: 20px;
    overflow: hidden;

    .status-indicator {
        width: 70px;
        height: 100%;
        background: #ffb100;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
    }

    &::v-deep i {
        width: 32px;
        height: 100%;
        border-left: 1px solid #96add0;
        border-right: 1px solid #96add0;
        cursor: pointer;

        &:hover {
            background: #d9d9d9;
        }
    }

    .icon-permission {
        width: 32px;
        height: 32px;
        cursor: pointer;

        ::v-deep img {
            transform: scale(0.5);
        }

        &:hover {
            background: #d9d9d9;
        }
    }
}

.campaign-detail-tabs {
    overflow: hidden;
    background: #ffffff;
}

::v-deep {
    .v-tabs__bar {
        background: #fff !important;
    }

    .v-tabs__item {
        text-transform: none !important;
        font-size: 14px !important;
        letter-spacing: normal !important;
        font-weight: 400 !important;
        margin-right: 0 !important;
        border-right: 1px solid #e4edfa;
        border-radius: 0 !important;
    }

    .v-tabs__wrapper {
        border-radius: 5px 5px 0 0 !important;
    }

    .v-tabs .v-tabs__bar .v-tabs__item:not(.v-tabs__item--active) {
        color: #12274f;
    }
    
    .theme--light.v-tabs__bar .v-tabs__item--disabled {
        color: #8A97AA !important;
    }

    .v-tabs .v-tabs__bar .v-tabs__item.v-tabs__item--active {
        background: linear-gradient(
                0deg,
                rgba(10, 108, 255, 0.1),
                rgba(10, 108, 255, 0.1)
            ),
            #ffffff !important;
        color: #0052cc !important;
        box-shadow: inset 0px -3px 0px #0052cc;
    }

    .v-tabs__container {
        border-bottom: 1px solid #e4edfa !important;
    }
}
</style>
